import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Cookies } from '../../../index.js';
import { BarLoader } from "react-spinners";
import StatusBadge from "../../../js/buttonstatus.jsx";

const HistoryList = () => {
    const [items, setItems] = useState(null);

    const fetchItems = () => {
        const apikey = Cookies.get('apikey');
        const params = apikey ? { apikey } : undefined;

        axios
            .get('https://hust.media/jop/mission/mode_p2p/history_lists.php', { params })
            .then((response) => {
                const data = Array.isArray(response.data) ? response.data : [];
                setItems(data);
            })
            .catch((error) => {
                console.log(error);
                setItems([]);
            });
    };

    useEffect(() => {
        fetchItems();
    }, []);

    if (!items) {
        return (
            <div className="mt-4 flex justify-center items-center">
                <BarLoader size={50} color="#003AA5" />
            </div>
        );
    }

    return (
        <div className="p-2">
            {items.length === 0 ? (
                <div className="text-center text-lg font-semibold text-gray-700">
                    Không có dữ liệu
                </div>
            ) : (
                <div className="grid gap-4">
                    {items.map((item, index) => {
                        const rowId = item.id_cash_approval || item.url_videos || `${index}`;

                        return (
                            <div
                                key={rowId}
                                className="rounded-lg border bg-white p-3 shadow-sm"
                            >
                                <div className="mb-2 flex flex-wrap items-center justify-between gap-2 text-sm">
                                    <div className="font-semibold">{item.username || 'No name'}</div>
                                    <div className="text-xs text-gray-600">{item.createdate}</div>
                                </div>
                                {item.url_videos && (
                                    <div className="mb-2">
                                        {item.category_code === "p2p_mmo_video" ? (
                                            <video
                                                className="w-full max-h-[360px] rounded"
                                                controls
                                                src={item.url_videos}
                                            />
                                        ) : (
                                            <img
                                                src={item.url_videos}
                                                alt="media"
                                                className="w-full max-h-[360px] rounded object-contain"
                                            />
                                        )}
                                    </div>
                                )}
                                {(item.note || item.status) && (
                                    <div className="mb-1 flex flex-wrap items-center justify-between gap-2 text-sm">
                                        <div className="text-gray-700">{item.note || ''}</div>
                                        {item.status && <StatusBadge status={item.status} />}
                                    </div>
                                )}
                                {Array.isArray(item.worker) && item.worker.length > 0 && (
                                    <div className="mb-1 text-base text-gray-700 whitespace-pre-line text-center">
                                        {item.worker
                                            .map((entry) => entry?.comments_orders)
                                            .filter(Boolean)
                                            .join("\n")}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default HistoryList;
